import { useMainStore } from "@/store";

export default (to, from, next) => {
  try {
    const store = useMainStore();
    const user = store.user;
    const hasStartedWelcome = store.hasStartedWelcome;

    if (!hasStartedWelcome) {
      // Jika belum pernah get started, arahkan ke /welcome
      if (to.path !== "/welcome") {
        next("/welcome");
      } else {
        next();
      }
    } else {
      // Jika sudah pernah get started
      if (user) {
        if (to.path === "/login" || to.path === "/welcome") {
          next("/home");
        } else {
          next();
        }
      } else {
        const publicPaths = ["/login", "/forgot-password", "/reset-password"];
        if (!publicPaths.includes(to.path)) {
          next("/login");
        } else {
          next();
        }
      }
    }
  } catch (error) {
    console.error("Error in route guard:", error);
    next("/welcome");
  }
};
